import { render } from "./MyStatisticsView.vue?vue&type=template&id=eaeae3fa&scoped=true"
import script from "./MyStatisticsView.vue?vue&type=script&lang=js"
export * from "./MyStatisticsView.vue?vue&type=script&lang=js"

import "./MyStatisticsView.vue?vue&type=style&index=0&id=eaeae3fa&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaeae3fa"]])

export default __exports__